import { ModuleCard } from '../../cards';
import { ContentList } from '../../ContentList';

import { selectSiteDiscoveryModuleRecord } from '../../../../../../store/features/discovery';
import { useRootSelector } from '../../../../../../store/hooks';
import { UseInfiniteScrollProps } from '../../../../../../hooks';

export interface ModuleListProps {
  loadMoreResults: UseInfiniteScrollProps['fetchMoreData'];
  enableLoadingByScroll: boolean;
}

export function ModuleList(props: ModuleListProps) {
  const { loadMoreResults, enableLoadingByScroll } = props;
  const { results, totalPages } = useRootSelector((state) =>
    selectSiteDiscoveryModuleRecord(state),
  );

  return (
    <ContentList
      items={results}
      totalPage={totalPages}
      onLoadMore={loadMoreResults}
      enableLoadingByScroll={enableLoadingByScroll}
    >
      {(item) => <ModuleCard data={item} />}
    </ContentList>
  );
}
